import { ButtonGroup } from 'primereact/buttongroup';
import { Button } from 'primereact/button';
import { ChevronUp } from '@primeicons/react/chevron-up';
import { ChevronDown } from '@primeicons/react/chevron-down';

function CircumstanceItem({ circumstance, handleClickCircumstance, onChange }) {
  return (
    <div className="flex flex-row gap-y-2">
      <div
        className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full border-b border-slate-200 last:border-b-0"
        onClick={handleClickCircumstance}>
        {circumstance.images.map((image) => (
          <img className="h-32 block rounded-md" src={image.file} alt={image.title} />
        ))}
        <div className="flex flex-col justify-around h-full w-full">
          <div className="text-xl font-bold  ">{circumstance.title}</div>
          <div className="text-base font-medium  ">{circumstance.description}</div>
        </div>
      </div>
      <ButtonGroup className="flex flex-col gap-x-2 h-full justify-center items-center">
        <Button
          variant="outlined"
          severity="primary"
          text
          raised
          iconOnly
          className="rounded-full"
          onClick={() => onChange(circumstance, -1)}>
          <ChevronUp />
        </Button>
        <Button
          variant="outlined"
          severity="primary"
          iconOnly
          text
          raised
          className="rounded-full"
          onClick={() => onChange(circumstance, 1)}>
          <ChevronDown />
        </Button>
      </ButtonGroup>
    </div>
  );
}

export default CircumstanceItem;
